import script from "./InstallPWADialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallPWADialog.vue?vue&type=script&setup=true&lang=js"

import "./InstallPWADialog.vue?vue&type=style&index=0&id=53353978&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53353978"]])

export default __exports__